import { Chart } from '@frontend/chart/types';

export interface TimeToStockoutItem {
    productKey: string;
    productName: string;
    stock: number;
    dailyRate: number;
    daysUntilEmpty: number;
}

const seriesTotal = (chart: Chart, name: string): number => {
    const series = chart.series.find((entry) => entry.name === name);
    if (!series) return 0;
    return series.data.reduce((sum, point) => sum + point.value, 0);
};

/** Days until empty from current stock ÷ average daily consumption over the lookback window. */
export const buildTimeToStockoutItems = (stock: Chart, consumption: Chart, lookbackDays: number): TimeToStockoutItem[] => {
    if (lookbackDays <= 0) return [];

    const productKeys = new Set<string>();
    for (const series of stock.series) {
        if (series.name?.trim()) productKeys.add(series.name);
    }
    for (const series of consumption.series) {
        if (series.name?.trim()) productKeys.add(series.name);
    }

    const items: TimeToStockoutItem[] = [];

    for (const productKey of productKeys) {
        const stockValue = seriesTotal(stock, productKey);
        const consumed = seriesTotal(consumption, productKey);
        if (stockValue <= 0 || consumed <= 0) continue;

        const dailyRate = consumed / lookbackDays;
        if (dailyRate <= 0) continue;

        items.push({
            productKey,
            productName: productKey,
            stock: stockValue,
            dailyRate: Math.round(dailyRate * 100) / 100,
            daysUntilEmpty: Math.round((stockValue / dailyRate) * 10) / 10
        });
    }

    return items.sort((left, right) => left.daysUntilEmpty - right.daysUntilEmpty);
};
